import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const EigenValuesAndEigenVectors = () => (
  <QPhototModuleSubtopic
    title="Eigen Values and Eigen Vectors"
    videos={[
      "https://www.youtube.com/embed/wVyCk5aZCnM",
      "https://www.youtube.com/embed/6e9lnpuLps8",
      "https://www.youtube.com/embed/s0rTXKdeZEQ",
      "https://www.youtube.com/embed/vD5R1gW1jp0",
      "https://www.youtube.com/embed/vlWttyc6bWc",
      "https://www.youtube.com/embed/JeebntOsfoI",
      "https://www.youtube.com/embed/hdd_c0GcOLY"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_54.png"},
        {image:"/cvla_55.png"},
        {image:"/cvla_56.png"},
        {image:"/cvla_57.png"},
    ]}
    exampleVideos={[]}
  />
);

export default EigenValuesAndEigenVectors;
